// ANGULAR
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AngularMaterialUtilModule } from './angular-material-util.module';

// DIRECTIVES
import { ClickOutsideDirective } from './shared-directives/click-outside.directive';
import { SidenavCollapseDirective } from './shared-directives/sidenav-collapse.directive';
import { ClickCursorDirective } from './shared-directives/click-cursor.directive';
import { WHChipListComponent } from './components/w-h-chip-list/w-h-chip-list.component';
import {
  UserPermissionPipe,
  WHImgAuthHeaderModule,
  WHPermissionCheckModule,
} from '@workheld/workheld-shared-lib';
import { InfiniteScrollAutoCompleteDirective } from './shared-directives/infinite-scroll-auto-complete.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FxFlexDirective } from './shared-directives/fxFlex.directive';
import { MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { WHAutocompleteStaticComponent } from './components/w-h-autocomplete-static/w-h-autocomplete-static.component';
import { WHItemAvatarComponent } from './components/w-h-item-avatar/w-h-item-avatar.component';
import { WHBackButtonComponent } from './components/buttons/w-h-back-button/w-h-back-button.component';
import { FileDragNDropDirective } from './shared-directives/w-h-files-dnd.directive';
import { WHPipesModule } from './shared-pipes/wh-pipes.module';
import { WHDialogOpenButtonComponent } from './components/buttons/w-h-dialog-open-button/w-h-dialog-open-button.component';

@NgModule({
  declarations: [
    ClickOutsideDirective,
    ClickCursorDirective,
    SidenavCollapseDirective,
    InfiniteScrollAutoCompleteDirective,
    FxFlexDirective,
    WHChipListComponent,
    WHBackButtonComponent,
    WHDialogOpenButtonComponent,
    WHAutocompleteStaticComponent,
    WHItemAvatarComponent,
    FileDragNDropDirective,
  ],
  exports: [
    CommonModule,
    AngularMaterialUtilModule,
    ClickOutsideDirective,
    ClickCursorDirective,
    SidenavCollapseDirective,
    WHBackButtonComponent,
    WHDialogOpenButtonComponent,
    InfiniteScrollAutoCompleteDirective,
    WHChipListComponent,
    FxFlexDirective,
    WHAutocompleteStaticComponent,
    WHItemAvatarComponent,
    FileDragNDropDirective,
    WHPipesModule,
    UserPermissionPipe,
    WHPermissionCheckModule,
    WHImgAuthHeaderModule,
  ],
  imports: [
    CommonModule,
    WHPipesModule,
    AngularMaterialUtilModule,
    WHImgAuthHeaderModule,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatRippleModule,
    UserPermissionPipe,
    WHPermissionCheckModule,
  ],
})
export class AppSharedModule {}
